"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TimeObject_1 = require("./TimeObject");
class AdAnalyticsVideoIndexKeywordSection {
    constructor({ start, end }) {
        this.toJSON = () => ({
            start: this.start,
            end: this.end,
        });
        this.start = start;
        this.end = end;
    }
}
AdAnalyticsVideoIndexKeywordSection.fromJSON = (json) => {
    const { start, end } = Object.assign({}, json);
    const _start = TimeObject_1.default.fromJSON(start);
    const _end = TimeObject_1.default.fromJSON(end);
    return new AdAnalyticsVideoIndexKeywordSection({
        start: _start,
        end: _end,
    });
};
exports.default = AdAnalyticsVideoIndexKeywordSection;
